import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import debounce from 'lodash/debounce'
import { getWidgetURL } from 'utils/widget'
import { beautifyURL } from 'utils/url'
import { withStyles } from '@material-ui/core/styles'
import { checkDomainName } from 'actions/domain'
import CircularProgress from '@material-ui/core/CircularProgress'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import connectActions from 'utils/connectActions'
import StepInput from './StepInput'

const styles = theme => ({
  root: {
    position: 'relative',
  },
  input: {
    position: 'relative',
  },
  back: {
    position: 'absolute',
    height: '2em',
    left: 0,
    top: 0,
    bottom: 0,
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 38 * 0.65,
    color: '#B3B3B1',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    paddingRight: (35 * 0.65) + (20 * 0.65),
    display: 'flex',
    alignItems: 'center',
  },
  backDomain: {
    paddingLeft: 25 * 0.65,
    visibility: 'hidden',
    color: '#363638',
    maxWidth: 542 * 0.65,
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'top',
    flexShrink: 0,
  },
  check: {
    position: 'absolute',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    lineHeight: 0,
    backgroundColor: '#fff',
  },
  checkIcon: {
    width: 35 * 0.65,
    height: 35 * 0.65,
  },
  checkIconSuccess: {
    color: theme.palette.primary.main,
  },
  checkIconFailure: {
    color: theme.palette.error.main,
  },
})

const mapActionsToProps = {
  checkDomainNameAction: checkDomainName
}

export default
@connectActions(mapActionsToProps)
@withStyles(styles)
class OnboardingDomainInput extends Component {
  static propTypes = {
    checkDomainNameAction: PropTypes.object.isRequired,
    classes: PropTypes.any.isRequired,
    dispatch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  }

  checkDomain = debounce(async (value) => {
    const { checkDomainNameAction, onStatusChange } = this.props
    if (!checkDomainNameAction.isPending && value && value.trim().length >= 5) {
      try {
        await checkDomainNameAction.run({
          params: [value],
        })
        onStatusChange(true)
      } catch (e) {
        onStatusChange(false, e)
      }
    }
  }, 500)

  handleChange = (ev) => {
    const { checkDomainNameAction, onChange, onStatusChange } = this.props
    ev.target.value = ev.target.value.trim() // eslint-disable-line
    checkDomainNameAction.reset({ updateComponent: false })
    onStatusChange(false)
    onChange(ev)
    this.checkDomain(ev.target.value)
  }

  render() {
    const {
      classes, value, checkDomainNameAction, dispatch, onChange, onStatusChange, ...rest
    } = this.props
    return (
      <div className={classes.root}>
        { !!value && (
          <div className={classes.back}>
            <div className={classes.backDomain}>
              { value }
            </div>
            { beautifyURL(getWidgetURL('')) }
            { checkDomainNameAction.isPending && (
              <div className={classes.check}>
                <CircularProgress size={35 * 0.65} color="secondary" />
              </div>
            ) }
            { checkDomainNameAction.isSucceded && (
              <div className={classes.check}>
                <CheckIcon className={classNames(classes.checkIcon, classes.checkIconSuccess)} />
              </div>
            ) }
            { checkDomainNameAction.isFailed && (
              <div className={classes.check}>
                <CloseIcon className={classNames(classes.checkIcon, classes.checkIconFailure)} />
              </div>
            ) }
          </div>
        ) }
        <StepInput
          className={classes.input}
          maxLength={128}
          placeholder={beautifyURL(getWidgetURL('username'))}
          value={value}
          onChange={this.handleChange}
          {...rest}
        />
      </div>
    )
  }
}
